<template>
  <layout-auth message="Setup Your Account!" :width="620">
    <b-loading :active="isPageLoading" :is-full-page="false"/>

    <div class="columns is-multiline mt-200">
      <div class="column is-6">
        <form-field-input
          label="First Name"
          v-model="form.first_name"
          :validation-errors="validationErrors.first_name"
          size=""
        />
      </div>

      <div class="column is-6">
        <form-field-input
          label="Last Name"
          v-model="form.last_name"
          :validation-errors="validationErrors.last_name"
          size=""
        />
      </div>

      <div class="column is-12">
        <form-field-input
          label="Email"
          v-model="form.email_address"
          :validation-errors="validationErrors.email_address"
          size=""
          type="email"
          v-autofocus
        />
      </div>

      <div class="column is-12">
        <form-field-password
          label="Password"
          v-model="form.password"
          :validation-errors="validationErrors.password"
          size=""
        />
      </div>

      <div class="column is-6">
        <form-field-input
          label="Company Name"
          v-model="form.company_name"
          :validation-errors="validationErrors.company_name"
          size=""
        />
      </div>

      <div class="column is-6">
        <form-field-timezones
          :validation-errors="validationErrors"
          :entity="form"
          size=""
        />
      </div>
    </div>

    <div class="has-text-centered">
      <button-default
        @click="formSubmit"
        :loading="isSaving"
        :disabled="isSaving"
        size=""
        class="auth_button"
      >Save
      </button-default>
    </div>
  </layout-auth>
</template>

<script>
import router from "../../router";
import api from "../../api";
import {ENUMS} from "../../services/enums";

export default {
  name: "SetupNewAccountPage",
  metaInfo: {
    title: "Account Setup"
  },
  data() {
    return {
      isPageLoading: true,
      isSaving: false,
      validationErrors: {},
      form: {
        first_name: null,
        last_name: null,
        email_address: null,
        password: null,
        timezone: 'America/Chicago',
        company_name: null,
      },
    }
  },
  mounted() {
    this.checkoutSessionInfo()
  },
  methods: {
    checkoutSessionInfo() {
      const sessionId = this.$route.query.session_id
      api.auth.checkoutSessionInfo(sessionId)
        .then((res) => {
          if (res.data.data.redirect_to_login) {
            window.location = '/login'
            return
          }

          if (this.$route.query.email) {
            this.form.email_address = this.$route.query.email
          }

          if (res.data.data) {
            this.form.first_name = res.data.data.first_name
            this.form.last_name = res.data.data.last_name
            this.form.email_address = res.data.data.email_address
          }

          this.isPageLoading = false
        })
    },
    formSubmit() {
      this.isSaving = true;

      api.auth.setupAccount(this.form)
        .then((response) => {
          if (response.data.white_glove_service) {
            this.$store.commit('onboarding/setWhiteGloveService');
          }

          router.push({name: "onboarding-welcome"})
        })
        .catch(error => {
          if (error.response.status === 422) this.validationErrors = error.response.data.errors;
        })
        .finally(() => this.isSaving = false)
    }
  }
}
</script>
